/**
 * Проверяет, что переданное значение не наследуется от Object.
 * @param value Проверяемое значение
 * @returns Истина, если значение является примитивом ECMAScript.
 */
export function isPrimitive(value) {
    return value !== Object(value);
}
